export default __webpack_public_path__ + "static/media/algorhythm.6038bef8.png";